export default __webpack_public_path__ + "3c5b4b47071b29194a0812a940db7f6d.png";